import { render, staticRenderFns } from "./Courtesy.vue?vue&type=template&id=15d12a08&scoped=true&"
import script from "./Courtesy.vue?vue&type=script&lang=js&"
export * from "./Courtesy.vue?vue&type=script&lang=js&"
import style0 from "./Courtesy.vue?vue&type=style&index=0&id=15d12a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d12a08",
  null
  
)

export default component.exports